/**
 * Theme controller — mirrors the redesign's shell.js behaviour.
 * Persists to localStorage under `jispman-theme`; toggles `data-theme` on <html>.
 * The initial value is applied by an inline script in index.html to avoid FOUC.
 */
export type Theme = 'light' | 'dark'

const KEY = 'jispman-theme'

export function getTheme(): Theme {
  const attr = document.documentElement.getAttribute('data-theme')
  return attr === 'dark' ? 'dark' : 'light'
}

export function setTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t)
  try {
    localStorage.setItem(KEY, t)
  } catch {
    /* storage unavailable — non-fatal */
  }
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === 'dark' ? 'light' : 'dark'
  setTheme(next)
  return next
}

export function initTheme(): void {
  let stored: string | null = null
  try {
    stored = localStorage.getItem(KEY)
  } catch {
    /* ignore */
  }
  setTheme(stored === 'dark' ? 'dark' : 'light')
}
